/**
 * Admin Configuration
 * 
 * For local development: Use the values below
 * For production: Set environment variables: REACT_APP_ADMIN_EMAIL
 * 
 * To set environment variable locally:
 * export REACT_APP_ADMIN_EMAIL="your-email@example.com"
 */

export const ADMIN_EMAIL = process.env.REACT_APP_ADMIN_EMAIL || 'dipen412@gmail.com';

